import { Routes, Theme, Users } from "@just-in-types";
import { NavigateFn } from "@reach/router";
import * as moment from "moment";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import { AnyAction, Dispatch } from "../../node_modules/redux";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import LoaderButton from "../components/LoaderButton";
import Row from "../components/Row";
import Text from "../components/Text";
import Title from "../components/Title";
import firebase from "../firebase";
import { firestore } from "../firebase";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import { addCheckIn, reset, Reset, setUpdatingMode, SetUpdatingMode } from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";

interface IThanksDispatchProps {
  onAddCheckIn: ({
    businessId,
    siteId,
    userId,
  }: {
    businessId: string;
    siteId: string;
    userId: string;
  }) => (dispatch: Dispatch<AnyAction>) => Promise<boolean>;
  onReset: Reset;
  onSetUpdatingMode: SetUpdatingMode;
}

interface IThanksOwnProps extends RouteComponentProps {
  bussiness: any;
  businessId: string;
  navigate: NavigateFn;
  siteId: string;
}

interface IThanksStateProps {
  languageStrings: IStrings;
  rootPath?: string;
  routes: Routes.RoutesObject;
  showCoupons: boolean;
  theme: Theme.Props;
  user: Users.User;
  userTemp: IState["userTemp"];
}

type ThanksProps = IThanksDispatchProps & IThanksOwnProps & IThanksStateProps;

interface IThanksState {
  expired: boolean;
  newSubscriber: null | boolean;
  sending: boolean;
  showCoupons: boolean;
  checkInsLeftText: string | null;
  optUser: boolean;
  rewardText: string | null;
  tearApartVehicle:boolean;
}

const ThanksContainer = styled(Container)`
  grid-template-rows: 1fr 2fr 1fr;
`;
ThanksContainer.displayName = "ThanksContainer";
const ThanksBody = styled("div")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 4rem;
  max-width: 90vw;
  margin: 0 auto;
`;
interface IThanksProps {
  color: any;
}
const ThanksText = styled(Text)`
  max-width: 50vw;
  color: ${(props: IThanksProps) => props.color || "rgb(252, 182, 18)"};
`;
const CouponsButton = styled(Button)`
  min-width: 16rem;
  margin: auto 0;
`;

const firstLetterUppercase = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

interface RouteButtonProps {
  colors: Theme.Colors;
  notEditable: string[];
  routes: Routes.RoutesObject;
  updating: boolean;
  strings: IStrings;
}

const buttonStrings = ({ notEditable, routes }) => {
  const routeStrings = Object.keys(routes) as Routes.RouteString[];

  return routeStrings
    .filter((routeString) => !notEditable.includes(routeString))
    .filter((routeString) => routes[routeString].enabled);
};

class Thanks extends React.Component<ThanksProps, IThanksState> {
  public state: IThanksState = {
    checkInsLeftText: null,
    expired: false,
    newSubscriber:null,
    optUser:false,
    rewardText: null,
    sending: false,
    showCoupons: false,
    tearApartVehicle:false,
  };
  public timeout: null | NodeJS.Timer = null;
  private adminMobiles = ["2693529412", "2144557285", "14052064211"];

  public async componentDidMount() {
    this.init();

    const { siteId, businessId, user} = this.props;    
    const tearApartCheckinSlc = (siteId && siteId === 'kv9ciglhFsJBh9YyV2sd' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartCheckinOgden = (siteId && siteId === '6vVH4qpzsVxjmROhMDmh' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartJoinSlc = (siteId && siteId === 'FDYHKAMSiYNCuXumk5Iv' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartJoinOgden = (siteId && siteId === 'TMrSaHl6j451pEWxY7nu' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartVehicleSlc = (siteId && siteId === '17VBJyeH2crmqQC2OSxx' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartVehicleOgden = (siteId && siteId === '1YYyeZ1YXjGyc6Z6vwRt' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;

    const tearApartVehicle = tearApartVehicleSlc || tearApartVehicleOgden;

    this.setState({ tearApartVehicle });

    const tearApart = ((siteId && siteId === 'bsZLKWJMaoIwztWi0gMg' && businessId && businessId === 'WpJtEW5saD7d4bRutXXb') || (siteId && siteId === 'JGOUaPdjCw7AxY1auyYy' && businessId && businessId === 'SmhXMTflviq60mlf221Z')) ? true : false;

    const tearApartAll = tearApartCheckinSlc
                        || tearApartCheckinOgden
                        || tearApart
                        || tearApartJoinOgden
                        || tearApartVehicleSlc
                        || tearApartVehicleOgden
                        || tearApartJoinSlc;

    if(tearApartAll && this.props.user && this.props.user.userId && this.props.user.userId === "opt-out"){
      this.setState({ optUser : true });
    }

    const newSubscriber = await this.newSubscriber(siteId, businessId, user.mobile);
    if(newSubscriber){
      this.setState({ newSubscriber : false });
    }else{
      this.setState({ newSubscriber : true });
    }

  }

  public componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  public init = async () => {
    const {
      onSetUpdatingMode,
      userTemp: { updating },
    } = this.props;

    this.setShowCoupons();
    onSetUpdatingMode(false);

    this.userReward();

    if (this.hasCheckedInToday()) {
      this.setState({ expired: true });
    } else if (!updating) {
      await this.checkIn();
    }

    // if (process.env.NODE_ENV !== 'development') {
    this.startTimeout();
    // }
  };

  public userReward = async () => {
    const {
      user,
      site: { showLoyaltyReward },
    } = this.props;

    if (user.userRewardText && showLoyaltyReward !== false) {
      const rewardText = user.userRewardText;
      this.setState({ rewardText });
    }
  };

  public startTimeout = () => {
    const { onReset, routes } = this.props;
    console.log(routes);
    const duration = (routes.thanks && routes.thanks.timeout) || 7000;

    this.timeout = setTimeout(() => onReset(), duration);
  };

  public checkIn = async () => {
    const {
      businessId,
      siteId,
      onAddCheckIn,
      user: { skipCheckIn, signature, userId },
    } = this.props;
    const checkIn: {
      businessId: string;
      signature?: string;
      siteId: string;
      userId: string;
    } = { businessId, siteId, userId };

    this.setState({ sending: true });

    if (signature) {
      checkIn.signature = signature;
    }

    if (userId) {
      if (!skipCheckIn) {
        console.log("call add check in");
        await onAddCheckIn(checkIn);
      }
    }

    this.setState({ sending: false });
  };

  public updateProfile = (path: string) => {
    const { navigate, onSetUpdatingMode, rootPath } = this.props;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    onSetUpdatingMode(true);

    navigate(`${rootPath}/${path}?from=thanks`);
  };

  public navigateToCoupons = () => {
    const { onSetUpdatingMode, navigate } = this.props;

    onSetUpdatingMode(true);

    navigate("../coupons");
  };

  public render() {
    const {
      languageStrings: strings,
      onReset,
      routes,
      businessId,
      siteId,
      theme: { colors },
      site: {
        kioskUiBackgroundColor,
        kioskUiTextColor,
        kioskUiTitleTextColor,
        kioskUiButtonPrimaryColor,
        kioskUiButtonErrorColor,
        kioskUiButtonSuccessColor,
        kioskUiVehicleConfig,
      },
      user: { loyaltyCycleText, userId },
      userTemp: { updating },
    } = this.props;
    const currentUser = this.props.user;
    const { expired, optUser, rewardText, sending, showCoupons, tearApartVehicle } = this.state;
    const notEditable: Routes.RouteString[] = ["covidquestions", "mobile", "signature", "thanks", "customertype"];

    const routeButtons = buttonStrings({ notEditable, routes }).map((routeString, index) => (
      <CouponsButton
        bg={
          updating
            ? kioskUiButtonSuccessColor
              ? kioskUiButtonSuccessColor
              : colors.success
            : kioskUiButtonPrimaryColor
            ? kioskUiButtonPrimaryColor
            : colors.primary
        }
        key={index}
        onClick={() => this.updateProfile(routeString)}
      >
        {strings[routeString] ? firstLetterUppercase(strings[routeString]) : firstLetterUppercase(routeString)}
      </CouponsButton>
    ));
    let wrenchAPartCoupon = null;
    if (businessId === "VQMWUEYKKs4rSpAzQ7P2") {
      if (siteId === "oOFy53wwUKI2WEZwXGNc") {
        // if austin location, don't show facebook coupon text
        wrenchAPartCoupon = strings.wapaustincheckin;
      } else {
        wrenchAPartCoupon = strings.wapfacebookcheckin;
      }
    }

    return (
      <ErrorBoundary>
        <ThanksContainer style={{ background: kioskUiBackgroundColor }}>
          <Row align="center" justify="center">
            {expired ? (
              <Title color={colors.warning}>{strings.alreadyCheckedIn}</Title>
            ) : (
              <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary}>
                {tearApartVehicle || kioskUiVehicleConfig ? strings.thanksHeaderVehicleTap : strings.thanksHeader}
              </Title>
            )}
          </Row>

          {currentUser.name.displayName ? (
            <div style={{ textAlign: "center" }}>
              <ThanksText color={kioskUiTextColor ? kioskUiTextColor : colors.secondary} textAlign="center" size="2rem">
                {(optUser && !tearApartVehicle && !kioskUiVehicleConfig) || (this.state.newSubscriber && !tearApartVehicle && !kioskUiVehicleConfig)?(strings.welcomeThanks + " " + currentUser.name.displayName + "!"):""}
                {!optUser && !tearApartVehicle && !kioskUiVehicleConfig && !this.state.newSubscriber && this.state.newSubscriber !== null ?(strings.welcomeBackThanks + " " + currentUser.name.displayName + "!"):""}
                {tearApartVehicle || kioskUiVehicleConfig?strings.welcomeThanksVehicleTap:""} 
                {/* {currentUser.name.displayName}! */}
              </ThanksText>
            </div>
          ) : null}

          {rewardText ? (
            <div style={{ textAlign: "center" }}>
              <ThanksText color={kioskUiTextColor ? kioskUiTextColor : colors.secondary} textAlign="center" size="2rem">
                {rewardText}
              </ThanksText>
            </div>
          ) : null}

          {loyaltyCycleText ? (
            <Row align="center" justify="center">
              <Title color={colors.warning}>{loyaltyCycleText}</Title>
            </Row>
          ) : null}

          {wrenchAPartCoupon !== null ? (
            <Row align="center" justify="center">
              <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary}>
                {wrenchAPartCoupon}
              </Title>
            </Row>
          ) : null}
          <Row align="center" justify="center">
            <LoaderButton
              bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
              disabled={sending}
              loading={sending}
              onClick={() => onReset()}
            >
              {strings.home}
            </LoaderButton>
          </Row>
          {userId === "opt-out" ? null : showCoupons ? (
            <ThanksBody>
              <Column justify="space-between">
                {/* <LoaderButton
                  bg={colors.success}
                  disabled={sending}
                  loading={sending}
                  onClick={() => onReset()}>
                  {strings.home}
                </LoaderButton> */}
                <ThanksText
                  color={kioskUiTextColor ? kioskUiTextColor : colors.secondary}
                  size="2.5rem"
                  textAlign="center"
                >
                  Edit your profile:
                </ThanksText>
                {routeButtons}
              </Column>
              <Column justify="space-between">
                <CouponsButton
                  bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                  onClick={this.navigateToCoupons}
                  size="2.5rem"
                >
                  Coupons
                </CouponsButton>
              </Column>
            </ThanksBody>
          ) : (
            <Column align="center" justify="space-around">
              {/* <LoaderButton
                bg={colors.success}
                disabled={sending}
                loading={sending}
                onClick={() => onReset()}>
                {strings.home}
              </LoaderButton> */}
              <ThanksText color={kioskUiTextColor ? kioskUiTextColor : colors.secondary} textAlign="center" size="2rem">
                {strings.tapBelow}
              </ThanksText>
              {routeButtons}
            </Column>
          )}
        </ThanksContainer>
      </ErrorBoundary>
    );
  }

  private hasCheckedInToday = () => {
    const {
      user: { mobile },
      userTemp: { checkIns },
    } = this.props;

    // if (
    //   process.env.NODE_ENV === 'development' ||
    //   this.adminMobiles.indexOf(mobile) !== -1
    // ) {
    //   return false;
    // }

    return checkIns.some(({ timestamp }) => moment(timestamp.toDate()).isSame(moment(), "day"));
  };
  private setShowCoupons = () => {
    const {
      showCoupons,
      userTemp: { coupons },
    } = this.props;
    const hasValidCoupons = coupons.some((coupon) => coupon.redemption_flag === false);

    if (showCoupons && hasValidCoupons) {
      this.setState({ showCoupons: true });
    }
  };

  private newSubscriber = async (siteId, businessId, mobile) => {
   
    let newSubscriber = 0;
    await firestore
      .collection("checkIns")
      .where("businessId", "==", businessId)
      .where("siteId", "==", siteId)
      .where("mobile", "==", mobile)
      .get()
      .then((snap)=>{
        newSubscriber = snap.size;
    });
    return newSubscriber;

  }

}

const mapStateToProps = ({
  router: { rootPath, languageStrings, routes, showCoupons, business },
  theme,
  user,
  userTemp,
}: IState) => ({
  business,
  languageStrings,
  rootPath,
  routes,
  showCoupons,
  theme,
  user,
  userTemp,
});

const mapDispatchToProps = {
  onAddCheckIn: addCheckIn,
  onReset: reset,
  onSetUpdatingMode: setUpdatingMode,
};

export default connect<IThanksStateProps, IThanksDispatchProps, IThanksOwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(Thanks);



// WEBPACK FOOTER //
// ./src/views/Thanks.tsx